import { render, staticRenderFns } from "./ServicesCheckboxAdministrador.vue?vue&type=template&id=47648fa3&"
import script from "./ServicesCheckboxAdministrador.vue?vue&type=script&lang=js&"
export * from "./ServicesCheckboxAdministrador.vue?vue&type=script&lang=js&"
import style0 from "./ServicesCheckboxAdministrador.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports